import * as yup from "yup";

export default yup.object().shape({
  category_id: yup.number().min(1, "The category field is required").required("The category field is required"),
  message: yup.string().required("The message field is required"),
  title: yup.string().required("The title field is required"),
  user_id: yup.number().min(1, "The User field is required").required("The User field is required"),
});
